import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import {
    useMultiParentlessResourceAdapterActions,
} from '../../../resource-base/adapters/useMultiParentlessResourceAdapterActions';
import { IdSchema } from '../../../resource-base/baseSchemas';
import { defaultPersistableResource, PersistableResourceSchema } from '../../../resource-base/persistableResourceTypes';

export enum SystemUserGroupRoleAssignmentPropertyValidation {
    SYSTEM_USER_GROUP = 'SYSTEM_USER_GROUP',
    SYSTEM_USER_ROLES = 'SYSTEM_USER_ROLES',
}

export const SystemUserGroupRoleAssignmentResourceSchema = PersistableResourceSchema.extend({
    systemUserGroup: IdSchema,
    systemUserRoles: IdSchema.array(),
    resourceType: z.literal(ResourceType.SYSTEM_USER_GROUP_ROLE_ASSIGNMENT).default(ResourceType.SYSTEM_USER_GROUP_ROLE_ASSIGNMENT),
});

export const SystemUserGroupRoleAssignmentMutationResourceSchema = getMutationSchema(SystemUserGroupRoleAssignmentResourceSchema);

export type SystemUserGroupRoleAssignmentResource = z.infer<typeof SystemUserGroupRoleAssignmentResourceSchema>;

export const defaultSystemUserGroupRoleAssignmentResource: SystemUserGroupRoleAssignmentResource = {
    ...defaultPersistableResource,
    resourceType: ResourceType.SYSTEM_USER_GROUP_ROLE_ASSIGNMENT,
    systemUserGroup: '',
    systemUserRoles: [],
};

export function useSystemUserGroupRoleAssignmentActions() {
    return useMultiParentlessResourceAdapterActions(
        'system-user-group-role-assignment',
        ResourceType.SYSTEM_USER_GROUP_ROLE_ASSIGNMENT,
        SystemUserGroupRoleAssignmentResourceSchema
    );
}
